import {
  collection,
  getCountFromServer,
  query,
  where,
} from "firebase/firestore";
import { db } from "../WebAppsSharedStuffs/utils/firebase";
import { PiNetworkService } from "./PiIntegration";

async function validatePiNetworkAccessToken(
  piAccessToken: string
): Promise<{ username: string }> {
  try {
    const { uid, username } =
      await PiNetworkService.connect().authWithPiNetworkApi(piAccessToken);
    return { username };
  } catch (error) {
    throw error;
  }
}

// A placeholder for the encryption function. It MUST produce the exact same
// output as the `encrypt` function on your backend.
function encrypt(password: string): string {
  console.warn(
    "The 'encrypt' function must be identical to your backend's version."
  );
  return "encrypted_" + password; // Replace with your actual encryption
}

// Helper to count users' referrals who have mined recently
async function countRecentMiners(userUid: string): Promise<number> {
  const now = new Date();
  const twoHoursAgo = new Date(now.getTime() - 2 * 60 * 60 * 1000);

  const q = query(
    collection(db, "athUsers"),
    where("referredBy", "==", userUid),
    where("lastMiningDate", ">=", twoHoursAgo)
  );

  const snapshot = await getCountFromServer(q);
  return snapshot.data().count;
}

// Helper to determine the next grant date
function getNextGrantDate(lastMiningDate: Date): Date {
  const now = new Date();
  const lastMining = new Date(lastMiningDate);
  const diffHours = Math.abs(now.getTime() - lastMining.getTime()) / 36e5;

  return diffHours >= 2
    ? now
    : new Date(lastMining.getTime() + 2 * 60 * 60 * 1000);
}
function createCombinedId(userId: string, withUserId: string): string {
  // Create an array of the user IDs
  const ids = [userId, withUserId];

  // Sort the array to ensure consistent ordering regardless of input order
  ids.sort();

  // Join the sorted IDs with a delimiter to create a single string
  return ids.join("-");
}

// ArthereumTokenomics class moved to the frontend
class ArthereumTokenomics {
  private initialBaseGrant: number;
  private userCount: number;

  constructor() {
    this.initialBaseGrant = 10;
    this.userCount = 20000; // Target user base for base grant calculation
  }

  calculateBaseGrant(): number {
    return this.initialBaseGrant / Math.log2(this.userCount + 1);
  }

  calculateNextGrantValue(
    referalsThatAreMiningCount: number,
    stakeBoost: number
  ): number {
    const baseGrant = this.calculateBaseGrant();
    const referralBoost = 1 + 0.05 * referalsThatAreMiningCount;
    const next = baseGrant * stakeBoost * referralBoost;
    return next;
  }
  calculateStakeBoost(
    stakeAmount: number,
    stakeTimePeriodInMonth: number = 1
  ): number {
    const stakeScalingFactor = 0.1; // Controls the influence of staked amount on boost
    return stakeAmount * stakeScalingFactor; // Ensures minimum boost of 1
  }
}

export const arthereumTokenomics = new ArthereumTokenomics();

// Export all helpers
export {
  countRecentMiners,
  encrypt,
  getNextGrantDate,
  validatePiNetworkAccessToken,
  createCombinedId,
};
